<template>
  <div class="goods-deal-detail">
    <!-- <div class='item'>
      <span class="label">时间</span>
      <span class="price">价格</span>
      <span class="count">数量</span>
    </div> -->
    <div class='item' v-for="(item,index) in list" :key="item.num || index" v-show="item.isShow" :class="activeIndex == index ? 'tick-active' : ''" @click="changeColor(index)">
      <span class="label">{{item.time}}</span>
      <span class="price" :class="item.color">{{item.price || '-'}}</span>
      <span class="count" :class="item.color">{{item.vol || '-'}}</span>
    </div>
  </div>
</template>
<script>
import { Chart } from 'hqchart'
import { getTicksList } from '@frame/api/chart/chart'
import unit from '@frame/utils/unit'
export default {
  name: 'fiveGrades',
  props: {
    preclosePx: {
      type: String | Number,
      default: 1
    },
    gradesData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    gradesCount: {
      type: Number,
      default: 0
    },
    sharesPerHand: {
      type: String | Number,
      default: 1
    }
  },
  data () {
    return {
      symbol: '',
      list: [],
      operator: null,
      defCount: 10,
      lineHeight: 17,
      diffHeight: 8,
      activeIndex: -1,
      dataCount: -1,
      showDetail: true
    }
  },
  created () {
    this.operator = Chart.IFrameSplitOperator
  },
  mounted () {
    this.monitorEvent()
  },
  beforeDestroy () {
    // 解绑 eventBus事件
    this.busOff(['showMoreTick'])
  },
  methods: {
    getDealDetail (res) {
      this.symbol = res
      this.qryMinuteTick()
    },
    qryMinuteTick () {
      this.$nextTick(() => {
        if (this.dataCount < 0) {
          this.dataCount = this.getQueryDataCnt()
          this.dataCount = this.dataCount < 21 ? 21 : this.dataCount
        }
        const opt = {
          prodCode: this.symbol,
          fields: 'business_time,hq_px,business_balance,business_amount,business_direction',
          dataCount: this.dataCount,
          searchDirection: 1
        }
        let rl = this.showDetail ? this.dataCount - this.diffHeight : this.dataCount
        getTicksList(opt)
          .then((r) => {
            if (r.data && r.data.tick && r.data.tick[this.symbol]) {
              let ticks = r.data.tick[this.symbol]
              let fields = r.data.tick.fields
              ticks = ticks.sort((a, b) => {
                let idx = this.getIndex(fields, 'business_time')
                // 成交时间升序排序
                return a[idx] - b[idx]
              })
              let tickArray = [], ln = ticks.length
              for (let i in ticks) {
                let item = ticks[i]
                let amount = item[this.getIndex(fields, 'business_amount')]
                if (amount <= 0) {
                  continue
                }
                let idx = this.getIndex(fields, 'business_time')
                let time = item[idx].toString().substr(8, 6).match(/\d{1,2}/g).join(':')
                let price = item[this.getIndex(fields, 'hq_px')]
                let balance = item[this.getIndex(fields, 'business_balance')]
                let color = price ? this.setClass(price) : ''
                tickArray.push({
                  time: time,
                  price: price !== 0 ? price.toFixed(2) : '-',
                  vol: amount !== 0 ? unit.priceFormat(amount/* / this.sharesPerHand */, 'businessAmount') : '-',
                  balance: balance !== 0 ? unit.priceFormat(balance, 'businessBalance') : '-',
                  color: color,
                  // hidden: i > 7
                  isShow: ln <= rl ? true : i > (ln - rl - 1)
                })
              }
              this.list = tickArray
            }
          })
          .catch((e) => {
            console.error(e)
          })
      })
    },
    refreshTicks (data) {
      if (this.localAmount < data.businessAmount) {
        this.localAmount = data.businessAmount
        this.qryMinuteTick()
      }
    },
    getIndex (fields, key) {
      return fields.findIndex((a) => a === key)
    },
    setClass (price) {
      return this.operator.FormatValueColor(price, this.preclosePx)
    },
    monitorEvent () {
      this.$bus.$on('showMoreTick', val => {
        this.showDetail = val
        if (this.list && this.list.length) {
          let ln = this.list.length, real = this.showDetail ? this.dataCount - this.diffHeight : this.dataCount
          for (let i in this.list) {
            let item = this.list[i]
            item.isShow = ln <= real ? true : i > (ln - real - 1) ? true : !val
          }
        }
      })
    },
    busOff (keys) {
      if (!Array.isArray(keys)) {
        keys = [keys]
      }
      for (const key of keys) {
        this.$bus.$off(key)
      }
    },
    selector (cls) {
      return document.querySelector(cls)
    },
    getQueryDataCnt () {
      let box = this.selector('.time-deal-box')
      let hdp = this.selector('.handicap')
      let deal = this.selector('.time-deal')
      let total = box.clientHeight
      let height = total - hdp.clientHeight - deal.clientHeight
      if (height > 0) {
        return Math.floor(height / this.lineHeight) + this.diffHeight
      }
      return this.defCount + this.diffHeight
    },
    changeColor (curIndex) {
      this.activeIndex = curIndex
    }
  }
}
</script>
<style lang="scss" scoped>
$border_color: #1e1e1e;
.goods-deal-detail {
  // padding-top: 1px;
  .item {
    padding: 0 4px 0 4px;
    line-height: 17px;
    display: flex;
    .label {
      width: 20%;
    }
    .price {
      width: 43%;
      text-align: right;
      font-size: 16px;
    }
    .count {
      text-align: right;
      width: 33%;
      font-size: 16px;
      margin-right: 10px;
    }
  }
}
.PriceNull {
  color: #909399;
}
.tick-active {
  background: #162A53;
}
</style>
